export default __webpack_public_path__ + "static/media/Reveal-nft-image.bf3f7e6d.svg";